<div class="contextmenu" [ngStyle]="{'left.px': x, 'top.px': y}" [ngClass]="{'d-none': !isShow}">
  <a (click)="orderBuy(0)" class="list-group-item list-group-item-action">
    {{"buy"|translate}} (F4)
  </a>
  <a (click)="orderBuy(1)" class="list-group-item list-group-item-action">
    {{"sell"|translate}} (F5)
  </a>
  <a (click)="setAlert()" class="list-group-item list-group-item-action">
    {{"set-alert"|translate}}
  </a>
  <a *ngIf="!isFav(item?.symbol)" (click)="toggleFav(item?.symbol)" class="list-group-item list-group-item-action">
    {{"add-fav"|translate}}
  </a>
  <a  *ngIf="isFav(item?.symbol)" (click)="toggleFav(item?.symbol)" class="list-group-item list-group-item-action">
    {{"rmv-fav"|translate}}
  </a>
  <a (click)="addWidgett('market-depth')" class="list-group-item list-group-item-action">
    {{"market-depth"|translate}}
  </a>
  <a (click)="addWidgett('bids')" class="list-group-item list-group-item-action">
    {{"bids"|translate}}
  </a>
  <a (click)="addWidgett('asks')" class="list-group-item list-group-item-action">
    {{"asks"|translate}}
  </a>
  <a (click)="addWidgett('news')" class="list-group-item list-group-item-action">
    {{"news"|translate}}
  </a>
  <a (click)="addWidgett('trades')" class="list-group-item list-group-item-action">
    {{"trades"|translate}} (F2)
  </a>
  <a (click)="addWidgett('historical')" class="list-group-item list-group-item-action">
    {{"history"|translate}}
  </a>
  <a (click)="navigateProfile()" class="list-group-item list-group-item-action">
    {{"company-profile"|translate}}
  </a>
  <!-- <a (click)="addWidgett('detailed-quota')" class="list-group-item list-group-item-action">
    {{"detailed-quota"|translate}}
  </a> -->
</div>
